import * as i0 from '@angular/core';
import { Injectable, EventEmitter, forwardRef, Component, Input, Output, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i2 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';

class UserRepository {
}
UserRepository.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepository, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
UserRepository.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepository, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepository, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class AADObjectSelectComponent {
    constructor(userRepository) {
        this.userRepository = userRepository;
        this.placeholder = '';
        this.iconClass = '';
        this.required = false;
        this.multiple = false;
        this.selectionMenuOpen = false;
        this.disabled = false;
        this.requestCancelationToken = { request: null };
        this.valueChanged = new EventEmitter();
        this.propagateChange = (_) => { };
    }
    ngOnInit() {
        this.setValidOrInvalid();
    }
    async searchUser() {
        this.cancelRequest();
        if (this.userNameTextField.length === 0) {
            this.user = null;
        }
        if (this.userNameTextField.length <= 2) {
        }
        else {
            this.users = await this.userRepository.getByFilter(this.userNameTextField, this.requestCancelationToken);
            this.selectionMenuOpen = true;
        }
        this.setValidOrInvalid();
    }
    closeMenu() {
        /** Timeout! The selectUser event has to fire first (with the click) then the focusout event.*/
        setTimeout((_) => {
            this.selectedUser = this.user;
            this.selectionMenuOpen = false;
            if (this.user) {
                this.userNameTextField = this.user.LastName + ', ' + this.user.FirstName;
            }
            else {
                this.userNameTextField = '';
            }
            this.publish();
        }, 300);
    }
    selectUser(user) {
        if (this.multiple === false) {
            this.user = user;
        }
        else {
            let userTmp = this.users.filter(u => u.Id === user.Id)[0];
            if (!userTmp) {
                this.users.push(user);
            }
        }
        this.setValidOrInvalid();
        this.publish();
    }
    setValidOrInvalid() {
        if (this.required === true && !this.user) {
            this.disabled = true;
        }
        else {
            this.disabled = false;
        }
    }
    removeUser(user) {
        let index = this.users.findIndex(u => u.Id === user.Id);
        this.users.splice(index, 1);
        this.publish();
    }
    publish() {
        if (this.multiple === true) {
            let pub = this.users && this.users.map(u => u.Id);
            this.propagateChange(pub);
            this.valueChanged.emit(this.users);
        }
        else {
            let pub = this.user && this.user.Id;
            this.propagateChange(pub);
            this.valueChanged.emit(this.user);
        }
    }
    cancelRequest() {
        if (this.requestCancelationToken && this.requestCancelationToken.request) {
            this.requestCancelationToken.request.unsubscribe();
        }
    }
    async writeValue(userIds) {
        if (!userIds) {
            return;
        }
        if (this.multiple) {
            let allUsers = [];
            let fetchPictureOnlyForFirstCounter = 10;
            for (let userId of userIds) {
                let user = await this.userRepository.getById(userId, fetchPictureOnlyForFirstCounter > 0, null);
                allUsers.push(user);
                fetchPictureOnlyForFirstCounter--;
            }
            this.users = this.persistedUsers;
        }
        else {
            await this.userRepository.getById(userIds, true, null);
            this.user = this.persistedUsers[0];
            const selectedUser = this.users[0];
            this.userNameTextField = selectedUser.LastName + ', ' + selectedUser.FirstName;
            this.selectedUser = selectedUser;
            this.selectionMenuOpen = false;
            this.user = selectedUser;
        }
        this.setValidOrInvalid();
    }
    validate() {
        return null;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
}
AADObjectSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AADObjectSelectComponent, deps: [{ token: UserRepository }], target: i0.ɵɵFactoryTarget.Component });
AADObjectSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.1", type: AADObjectSelectComponent, selector: "app-aad-object-select", inputs: { placeholder: "placeholder", iconClass: "iconClass", required: "required", multiple: "multiple" }, outputs: { valueChanged: "valueChanged" }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AADObjectSelectComponent),
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AADObjectSelectComponent),
            multi: true
        },], ngImport: i0, template: "<mat-form-field appearance=\"outline\">\r\n   <mat-label>Search someone</mat-label>\r\n   <input matInput \r\n          [placeholder]=\"placeholder\"\r\n          [(ngModel)]=\"userNameTextField\"\r\n          (input)=\"searchUser()\"\r\n          (focusout)=\"closeMenu()\">\r\n </mat-form-field>\r\n \r\n\r\n<div class=\"bs-user-list-wrapper\"\r\n     *ngIf=\"selectionMenuOpen\">\r\n   <div class=\"bs-user-list-outer\">\r\n      <div class=\"bs-user-out\"\r\n           *ngFor=\"let user of users\">\r\n\r\n         <div  class=\"bs-user-outer\"               \r\n               (mousedown)=\"selectUser(user)\">\r\n            <div class=\"bs-user-thumb\">\r\n               <img [src]=\"user.ProfilePictureBase64\"\r\n                    onerror=\"this.onerror=null; this.src='../../../../assets/thumb.png'\">\r\n            </div>\r\n            <div class=\"bs-user-info\" >\r\n               <div class=\"bs-user-name\">{{user.LastName}}, {{user.FirstName}}</div>\r\n               <div class=\"bs-user-job-title\">{{user.JobTitle}}</div>\r\n            </div>\r\n            <div class=\"clear-both\"></div>\r\n         </div>\r\n      </div>\r\n   </div>\r\n</div>\r\n\r\n<div class=\"bs-user-list-selected-outer\"\r\n     *ngIf=\"multiple === true\">\r\n   <div class=\"bs-user-out\"\r\n        *ngFor=\"let user of users\">\r\n      <div  class=\"bs-user-outer\">\r\n         <div class=\"bs-user-thumb\">\r\n            <img [src]=\"user.ProfilePictureBase64\"\r\n                 onerror=\"this.onerror=null; this.src='../../../../assets/thumb.png'\">\r\n         </div>\r\n         <div class=\"bs-user-info\" >\r\n            <div class=\"bs-user-name\">{{user.LastName}}, {{user.FirstName}}</div>\r\n         </div>\r\n         <div class=\"bs-user-remove\"\r\n              (click)=\"removeUser(user)\">\r\n            X\r\n         </div>\r\n         <div class=\"clear-both\"></div>\r\n      </div>\r\n   </div>\r\n</div>", styles: [".bs-user-list-wrapper{z-index:2;position:relative}.bs-user-thumb{margin:8px 3px 3px;float:left}.bs-user-thumb img{width:40px;border-radius:100px}.bs-user-list-outer{position:absolute;background-color:#fff;box-shadow:#0006 0 0 5px;height:100%;display:flex;flex-direction:column}.bs-user-list-outer .bs-user-out .bs-user-outer{height:55px;margin:2px 5px;cursor:pointer}.bs-user-list-outer .bs-user-out .bs-user-outer .bs-user-info{float:left;margin-left:3px;margin-top:3px}.bs-user-list-outer .bs-user-out .bs-user-outer .bs-user-info .bs-user-job-title{font-size:11px;color:#313030}.bs-user-list-outer .bs-user-out:hover{background-color:#e4e4e4}.bs-user-list-selected-outer .bs-user-out .bs-user-outer .bs-user-info{float:left;margin-left:3px;margin-top:3px}.bs-user-list-selected-outer .bs-user-out .bs-user-outer .bs-user-remove{float:left;margin-left:7px;font-weight:700;cursor:pointer}\n"], dependencies: [{ kind: "component", type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: AADObjectSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-aad-object-select', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => AADObjectSelectComponent),
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef(() => AADObjectSelectComponent),
                            multi: true
                        },], template: "<mat-form-field appearance=\"outline\">\r\n   <mat-label>Search someone</mat-label>\r\n   <input matInput \r\n          [placeholder]=\"placeholder\"\r\n          [(ngModel)]=\"userNameTextField\"\r\n          (input)=\"searchUser()\"\r\n          (focusout)=\"closeMenu()\">\r\n </mat-form-field>\r\n \r\n\r\n<div class=\"bs-user-list-wrapper\"\r\n     *ngIf=\"selectionMenuOpen\">\r\n   <div class=\"bs-user-list-outer\">\r\n      <div class=\"bs-user-out\"\r\n           *ngFor=\"let user of users\">\r\n\r\n         <div  class=\"bs-user-outer\"               \r\n               (mousedown)=\"selectUser(user)\">\r\n            <div class=\"bs-user-thumb\">\r\n               <img [src]=\"user.ProfilePictureBase64\"\r\n                    onerror=\"this.onerror=null; this.src='../../../../assets/thumb.png'\">\r\n            </div>\r\n            <div class=\"bs-user-info\" >\r\n               <div class=\"bs-user-name\">{{user.LastName}}, {{user.FirstName}}</div>\r\n               <div class=\"bs-user-job-title\">{{user.JobTitle}}</div>\r\n            </div>\r\n            <div class=\"clear-both\"></div>\r\n         </div>\r\n      </div>\r\n   </div>\r\n</div>\r\n\r\n<div class=\"bs-user-list-selected-outer\"\r\n     *ngIf=\"multiple === true\">\r\n   <div class=\"bs-user-out\"\r\n        *ngFor=\"let user of users\">\r\n      <div  class=\"bs-user-outer\">\r\n         <div class=\"bs-user-thumb\">\r\n            <img [src]=\"user.ProfilePictureBase64\"\r\n                 onerror=\"this.onerror=null; this.src='../../../../assets/thumb.png'\">\r\n         </div>\r\n         <div class=\"bs-user-info\" >\r\n            <div class=\"bs-user-name\">{{user.LastName}}, {{user.FirstName}}</div>\r\n         </div>\r\n         <div class=\"bs-user-remove\"\r\n              (click)=\"removeUser(user)\">\r\n            X\r\n         </div>\r\n         <div class=\"clear-both\"></div>\r\n      </div>\r\n   </div>\r\n</div>", styles: [".bs-user-list-wrapper{z-index:2;position:relative}.bs-user-thumb{margin:8px 3px 3px;float:left}.bs-user-thumb img{width:40px;border-radius:100px}.bs-user-list-outer{position:absolute;background-color:#fff;box-shadow:#0006 0 0 5px;height:100%;display:flex;flex-direction:column}.bs-user-list-outer .bs-user-out .bs-user-outer{height:55px;margin:2px 5px;cursor:pointer}.bs-user-list-outer .bs-user-out .bs-user-outer .bs-user-info{float:left;margin-left:3px;margin-top:3px}.bs-user-list-outer .bs-user-out .bs-user-outer .bs-user-info .bs-user-job-title{font-size:11px;color:#313030}.bs-user-list-outer .bs-user-out:hover{background-color:#e4e4e4}.bs-user-list-selected-outer .bs-user-out .bs-user-outer .bs-user-info{float:left;margin-left:3px;margin-top:3px}.bs-user-list-selected-outer .bs-user-out .bs-user-outer .bs-user-remove{float:left;margin-left:7px;font-weight:700;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: UserRepository }]; }, propDecorators: { placeholder: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], required: [{
                type: Input
            }], multiple: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }] } });

class UserEntity {
}

class UserRepositoryService extends UserRepository {
    constructor(http) {
        super();
        this.http = http;
        this.graphBasePath = 'https://graph.microsoft.com/v1.0/';
    }
    mapFromGraphUserToUserEntity(graphUser) {
        const user = new UserEntity();
        user.Id = graphUser.id;
        user.FirstName = graphUser.givenName;
        user.LastName = graphUser.surname;
        user.EmailAdress = graphUser.mail;
        if (graphUser.jobTitle) {
            user.JobTitle = graphUser.jobTitle;
        }
        else {
            user.JobTitle = '';
        }
        return user;
    }
    mapFromGraphUsersToUserEntities(graphUsers) {
        const userEntities = [];
        if (!graphUsers || !graphUsers.value || !graphUsers.value.length) {
            return userEntities;
        }
        graphUsers = graphUsers.value;
        graphUsers.forEach((graphUser) => {
            const userEntity = this.mapFromGraphUserToUserEntity(graphUser);
            userEntities.push(userEntity);
        });
        return userEntities;
    }
    async getById(userId, fetchPicture, requestReference = { request: null }) {
        return new Promise((resolve, reject) => {
            if (!userId) {
                resolve(new UserEntity());
            }
            const cachedUserStorage = localStorage.getItem(userId);
            if (cachedUserStorage) {
                const cachedUser = JSON.parse(cachedUserStorage);
                resolve(cachedUser);
            }
            else {
                const request = this.http.get(this.graphBasePath + 'users/' + userId).subscribe(async (result) => {
                    const user = this.mapFromGraphUserToUserEntity(result);
                    if (fetchPicture === true) {
                        try {
                            const blob = await this.http.get(this.graphBasePath + 'users/' + userId + '/photos/96x96/$value', { responseType: 'blob' }).toPromise();
                            user.ProfilePictureBase64 = await this.createImageFromBlob(blob);
                            localStorage.setItem(user.Id, JSON.stringify(user));
                        }
                        catch (error) {
                            user.ProfilePictureBase64 = null;
                            localStorage.setItem(user.Id, JSON.stringify(user));
                        }
                    }
                    resolve(user);
                }, error => {
                    reject('User not found');
                });
                if (requestReference) {
                    requestReference.request = request;
                }
            }
        });
    }
    async getCurrentUser() {
        const user = await this.http.get(this.graphBasePath + 'me/').toPromise();
        const realUser = this.mapFromGraphUserToUserEntity(user);
        try {
            const blob = await this.http.get(this.graphBasePath + 'me/photos/96x96/$value', { responseType: 'blob' }).toPromise();
            realUser.ProfilePictureBase64 = await this.createImageFromBlob(blob);
            localStorage.setItem(user.Id, JSON.stringify(user));
        }
        catch (error) {
            realUser.ProfilePictureBase64 = null;
        }
        return realUser;
    }
    async createImageFromBlob(image) {
        let prom = new Promise(resolve => {
            let reader = new FileReader();
            reader.addEventListener("load", () => {
                resolve(reader.result);
            }, false);
            if (image) {
                reader.readAsDataURL(image);
            }
        });
        return prom;
    }
    getByEmailAdress(emailAdress) {
        throw new Error('Method not implemented.');
    }
    async getByFilter(filterString, requestReference) {
        return new Promise((resolve, reject) => {
            const requestUrl = this.graphBasePath + 'users?$filter=startswith(givenName, \'' + filterString + '\') or startswith(surname, \'' + filterString + '\')';
            const response = this.http.get(requestUrl).subscribe(async (result) => {
                const users = this.mapFromGraphUsersToUserEntities(result);
                const usersWithPicture = [];
                for (const user of users) {
                    const userWithPicture = await this.getById(user.Id, true);
                    usersWithPicture.push(userWithPicture);
                }
                resolve(usersWithPicture);
            }, error => {
                reject(error);
            });
            requestReference.request = response;
        });
    }
}
UserRepositoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepositoryService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
UserRepositoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepositoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: UserRepositoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class DataHiveNgxGraphModule {
}
DataHiveNgxGraphModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DataHiveNgxGraphModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataHiveNgxGraphModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.1", ngImport: i0, type: DataHiveNgxGraphModule, declarations: [AADObjectSelectComponent], imports: [MatFormFieldModule,
        MatInputModule,
        CommonModule,
        FormsModule], exports: [AADObjectSelectComponent] });
DataHiveNgxGraphModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DataHiveNgxGraphModule, providers: [
        { useClass: UserRepositoryService, provide: UserRepository }
    ], imports: [MatFormFieldModule,
        MatInputModule,
        CommonModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.1", ngImport: i0, type: DataHiveNgxGraphModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AADObjectSelectComponent
                    ],
                    imports: [
                        MatFormFieldModule,
                        MatInputModule,
                        CommonModule,
                        FormsModule
                    ],
                    providers: [
                        { useClass: UserRepositoryService, provide: UserRepository }
                    ],
                    exports: [
                        AADObjectSelectComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AADObjectSelectComponent, DataHiveNgxGraphModule, UserEntity, UserRepository, UserRepositoryService };
